// Function to update the mobile-show element
function updateMobileShow() {
  const hideElement = document.querySelector('.product__price.mobile-hide');
  const showElement = document.querySelector('.product__price.mobile-show');
  
  if (hideElement && showElement) {
    showElement.innerHTML = hideElement.innerHTML;
  }
}

// Set up a MutationObserver to watch for changes in the .product__price.mobile-hide element
const targetNode = document.querySelector('.product__price.mobile-hide');

if (targetNode) {
  // Options for the observer (which mutations to observe)
  const config = { childList: true, subtree: true, characterData: true };
  
  // Create a callback function to execute when mutations are observed
  const callback = (mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList' || mutation.type === 'characterData') {
        updateMobileShow();
      }
    }
  };
  
  // Create an instance of MutationObserver with the callback
  const observer = new MutationObserver(callback);
  
  // Start observing the target node for configured mutations
  observer.observe(targetNode, config);
  
  // Initial update in case the content is already present
  updateMobileShow();
}